import { Injectable } from '@jack-henry/frontend-utils/di';
import { CompaniesClient } from '@treasury/api/bo';
import CompanyRequests from '../../requests/companies/company-requests';
import { CompanySearchResult } from './entities/company-search-result.entity';

export enum CompanySearchField {
    CompanyName = 'Company+Name',
    CompanyId = 'Company+Id',
    CompanyTaxNumber = 'TAX+ID+Number',
    CompanyCifNumber = 'CIF+Number',
}

@Injectable()
export class CompanySearchService {
    constructor(private readonly companiesClient: CompaniesClient) {}

    public static async fetchCompanies() {
        return CompanyRequests.fetchCompanies();
    }

    public static async fetchNotOnboardedCompanies(parameters: object) {
        return CompanyRequests.fetchNotOnboardedCompanies(parameters);
    }

    /**
     * Searches for companies by company name.
     */
    public async getCompanies() {
        const resp = await this.companiesClient.companiesGet({
            searchType: CompanySearchField.CompanyName,
            searchValue: '',
        });

        return (
            resp.data
                .map(c => new CompanySearchResult(c))
                // The data from the API contains some invalid entries that we need to filter out.
                .filter(c => !['0', '1', 'items'].includes(c.cifNumber ?? ''))
        );
    }

    /**
     * Searches for companies that are not onboarded.
     */
    public async alternateSearch(field: CompanySearchField, searchTerm: string) {
        const resp = await this.companiesClient.companiesNonOnboardedCompanies({
            searchType: field,
            searchValue: searchTerm,
        });

        return resp.data.map(c => new CompanySearchResult(c));
    }
}

export default CompanySearchService;
